<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 13:21:52
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:57:57
 * @name: 还款周期
 * @Description: 还款周期
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\edit-cycle.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="还款周期" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label"><i class="warn">*</i>还款周期:</font>
          <el-select
            class="input"
            v-model="form.cycle"
            placeholder="请选择还款周期"
          >
            <el-option
              v-for="item of pianoCompany.cycles"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <font class="append">月</font>
        </div>
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from "@/utils/decorator";

export default {
  name: "pianoCompanyManage-editCycle",
  components: {
    addNeditDialog,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      id: "", //琴行表格操作行id
      form: {
        //表单数据
      },
    };
  },
  computed: {
    // 验证还款周期是否已填
    cycle_match() {
      return this.form.cycle === "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.form = {
        cycle: "",
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Number} id 琴行表格操作行id
     */
    open(row) {
      this.initData();
      this.id = row.id || "";
      this.form.cycle = row.credit_month || "";
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.id = "";
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      this.$emit("editCycle", { id: this.id, form: this.form });
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
  .append {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    padding: 0 20px;
    flex-shrink: 0;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>